/** @jsx createElement */
import { observer } from 'mobx-react';
import { createElement, Component, HTMLAttributes } from 'react';
import ReactDOM from 'react-dom';
import { KeyboardShortcuts } from '../keyboard-shortcuts';
import anime from 'animejs';
import { activate, deactivate, shimmer, activateShimmer } from '../helpers';
import { AnimatedSlide } from '../animated-slide';

// Players
import { PlayerCircleIcon } from '../players/circle-icon';
import { PlayerTextBlock } from '../players/text-block';

// Icons
import { Directory } from '../svg/directory';
import { Lock } from '../svg/lock';

@observer
export class Slide15 extends AnimatedSlide {
  // Animation players
  players = {
    lock: null,
    vpn: null,
  };

  // Run the first animation
  componentDidMount() {
    const { lock, vpn } = this.players;

    this.steps = [
      // Step 1
      () => {
        this.animateProgress(4000);
        this.autoNext(2000);
      },
      // Step 2
      () => {},
    ];

    this.animations = [
      //
      // Step 1
      //
      [
        {
          targets: lock,
          opacity: 1,
          delay: 0,
          duration: 200,
          begin: activateShimmer,
        },
      ],
      //
      // Step 2
      //
      [
        {
          targets: vpn,
          opacity: 1,
          delay: 0,
          duration: 200,
          begin: activateShimmer,
        },
      ],
    ];

    // Play the first animation
    this.play();
  }

  render() {
    const { children, className = '' } = this.props;

    return (
      <div className={`slide-15 ${className}`}>
        {children}
        <div className="content">
          {/* Results (SURICATA) */}
          <div
            className="player vpn"
            data-active="0"
            ref={node => (this.players.vpn = node)}
          >
            <PlayerTextBlock
              title={'VPN Info'}
              className={'red-top'}
              showDots={true}
              sections={[
                {
                  title: ['Client IP', '132.232.163.233'],
                  grid: 2,
                  animate: true,
                },
                {
                  title: ['ST=Beijing/cc=CN/c=Apnic'],
                  animate: true,
                  delay: 400,
                },
              ]}
            />
          </div>

          {/* Folder */}
          <div
            className="player lock"
            data-active="0"
            ref={node => (this.players.lock = node)}
          >
            <PlayerCircleIcon
              color={'#ffffff'}
              Icon={Lock}
              IconSize={'50'}
              showTitle={false}
            />
          </div>
        </div>
      </div>
    );
  }
}
